import React from "react";
import moment from "moment";
import { RiHistoryLine, RiBookOpenLine, RiTimeLine } from "react-icons/ri";
import Table from "../../admin/utils/Table/Table";
import "./myOrderHistory.scss";

const MyOrderHistory = () => {
  const columns = [
    {
      Header: "Сургалтын гарчиг",
      accessor: "course_title",
      Cell: ({ value }) => (
        <div className="orderHistoryTable__courseCell">
          <div className="orderHistoryTable__courseIcon">
            <RiBookOpenLine />
          </div>
          <div className="orderHistoryTable__courseText">
            <span>{value || "-"}</span>
          </div>
        </div>
      ),
    },
    {
      Header: "Ирсэн огноо",
      accessor: "created_at",
      disableFilters: true,
      Cell: ({ value }) => (
        <div className="orderHistoryTable__dateCell">
          <RiTimeLine />
          <span>{value ? moment(value).format("YYYY/MM/DD HH:mm") : "-"}</span>
        </div>
      ),
    },
  ];

  return (
    <div className="orderHistoryPage">
      <div className="orderHistoryCard">
        <div className="orderHistoryCard__header">
          <div>
            <div className="orderHistoryCard__eyebrow">My account</div>
            <h3 className="orderHistoryCard__title">Миний захиалгын түүх</h3>
            <p className="orderHistoryCard__desc">
              Таны өмнө илгээсэн сургалтын хүсэлтүүд болон бүртгэлийн түүх.
            </p>
          </div>

          <div className="orderHistoryCard__badge">
            <RiHistoryLine />
            <span>History</span>
          </div>
        </div>

        <div className="orderHistoryStats">
          <div className="orderHistoryStats__item">
            <div className="orderHistoryStats__icon">
              <RiBookOpenLine />
            </div>
            <div>
              <div className="orderHistoryStats__label">Захиалга</div>
              <div className="orderHistoryStats__value">
                Сургалтын хүсэлтүүд
              </div>
            </div>
          </div>

          <div className="orderHistoryStats__item">
            <div className="orderHistoryStats__icon">
              <RiTimeLine />
            </div>
            <div>
              <div className="orderHistoryStats__label">Огноо</div>
              <div className="orderHistoryStats__value">Илгээсэн хугацаа</div>
            </div>
          </div>
        </div>

        <div className="orderHistoryTableWrap">
          <Table
            apiPath="/users_courses"
            apiSubPath="requests/user"
            columns={columns}
            rowCount={5}
            useUserConfig
            disableActions
          />
        </div>
      </div>
    </div>
  );
};

export default MyOrderHistory;
